const isOnScreen = (elementId, granularity, callback, clear) => {
    if (typeof granularity === "function") {
        callback = granularity;
        granularity = 500;
    }
    const interval = setInterval(() => {
        const element = document.getElementById(elementId);
        if (
            element.getBoundingClientRect().top < window.innerHeight &&
            element.getBoundingClientRect().top > 0
        ) {
            callback("in-view");
            if (clear) clearInterval(interval);
        } else if (element.getBoundingClientRect().top > window.innerHeight) {
            callback("yet-to-reach");
        } else {
            callback("scrolled-past");
        }
        return (
            element.getBoundingClientRect().top < window.innerHeight &&
            element.getBoundingClientRect().top > 0
        );
    }, granularity);
};

export default isOnScreen;
